class StockLocationProductCountController extends AbstractStockLocationController
	@register()
	@inject 'stockLocation',
		'shops'
		'categories'

	initialize: ->
		super()

		@productsToCountFilter =
			stock_location_id: @stockLocation.id
			shop_id: null
			product_category_id: null
